import { Route } from "react-router-dom";

import Diabetes from "../pages/leistungen/diabetes";
import Impfen from "../pages/leistungen/impfen";
import EKG from "../pages/leistungen/ekg";
import Ergometrie from "../pages/leistungen/ergometrie";
import Echokardiographie from "../pages/leistungen/echokardiographie";
import Carotis from "../pages/leistungen/carotis";
import Schilddrüsenuntersuchung from "../pages/leistungen/schilddruese";
import Opf from "../pages/leistungen/opf";
import Schrittmacher from "../pages/leistungen/schrittmacher";
import Patientenvefuegung from "../pages/leistungen/patientenverfuegung";
import Rauchen from "../pages/leistungen/raucher";
import EKG24 from "../pages/leistungen/ekg24";
import Blutmessung24 from "../pages/leistungen/blutmessung24";
import Herzinsuffizienz from "../pages/leistungen/herzinsuffizienz";
import Vorsorge from "../pages/leistungen/vorsorge";
import Tauchen from "../pages/leistungen/tauchen";

const LeistungenRoutes = [
    <Route path="/leistungen/diabetes" element={<Diabetes />}/>,
    <Route path="/leistungen/impfen" element={<Impfen />}/>,
    <Route path="/leistungen/ekg" element={<EKG />}/>,
    <Route path="/leistungen/ergometrie" element={<Ergometrie />}/>,
    <Route path="/leistungen/echokardiographie" element={<Echokardiographie />}/>,
    <Route path="/leistungen/carotis" element={<Carotis />}/>,
    <Route path="/leistungen/schilddruese" element={<Schilddrüsenuntersuchung />}/>,
    <Route path="/leistungen/opf" element={<Opf />}/>,
    <Route path="/leistungen/schrittmacher" element={<Schrittmacher />}/>,
    <Route path="/leistungen/patientenverfuegung" element={<Patientenvefuegung />}/>,
    <Route path="/leistungen/raucherentwoehnung" element={<Rauchen />}/>,
    <Route path="/leistungen/24stunden_ekg" element={<EKG24 />}/>,
    <Route path="/leistungen/24stunden_blutmessung" element={<Blutmessung24 />}/>,
    <Route path="/leistungen/herzinsuffizienz" element={<Herzinsuffizienz />}/>,
    <Route path="/leistungen/vorsorge" element={<Vorsorge />}/>,
    <Route path="/leistungen/tauchen" element={<Tauchen />}/>

]
    
export default LeistungenRoutes;
